import React from 'react';

/**
 * Barra superior del Baby Shower Dulce Recuerdo.
 * Sin contador ni urgencia: solo refuerza qué es el producto.
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 border-b border-[#EADFCF] bg-[#FBD3E0] shadow-[0_2px_10px_rgba(139,107,85,0.10)]" data-id="element-79" data-mp="3t59kwz9cv11m">
      <div className="mx-auto flex min-h-[2.75rem] max-w-6xl items-center justify-center px-4 py-2 text-center text-[12.5px] font-semibold text-ink sm:text-sm" data-id="element-80" data-mp="3jddgz7kl8gph">
        <p data-id="element-81" data-mp="avqtfcbqeizw">
          <span aria-hidden="true" data-id="element-82" data-mp="aw0o3d7q1ebx">🎀 </span>
          Baby Shower Dulce Recuerdo
          <span className="mx-2 text-[#B8957C]" aria-hidden="true" data-id="element-83" data-mp="fw51gudc1sxx">·</span>
          <span className="hidden sm:inline" data-id="element-84" data-mp="1wdjyjnlxuf6">
            Versiones rosa y celeste incluidas
            <span className="mx-2 text-[#B8957C]" aria-hidden="true" data-id="element-85" data-mp="5xfkd3t9gciq">·</span>
          </span>
          Descarga digital
        </p>
      </div>
    </div>;
}